import { RichUtils } from 'draft-js';
import { useCallback } from 'react';

var useHandleKeyCommandCallback = function useHandleKeyCommandCallback(setEditorState) {
  return useCallback(function (command, editorState) {
    var newState = RichUtils.handleKeyCommand(editorState, command);

    if (newState) {
      setEditorState(newState);
      return 'handled';
    }

    return 'not-handled';
  }, [setEditorState]);
};

export default useHandleKeyCommandCallback;